import React from "react";
import {default as ReactMarkdown} from "react-markdown";
import {makeStyles} from "@mui/styles";


export type MarkdownProps = {
    children?: any
}


const useStyles = makeStyles(theme => ({
    root: {
        "& p": {
            padding: 0,
            margin: 0,
        },
        "& strong": {

        },
        "& ul": {
            paddingLeft: 23,
            listStyleType: "disc",
            margin: 2,
        },
        "& a": {
            color: '#009ACF',
        },
        "& h6": {
            fontSize: '12px',
            marginBlockStart: '1em',
            marginBlockEnd: '1em',
            fontWeight: 'unset'
        }
    }
}))


export const Markdown = (props: MarkdownProps) => {
    const classes = useStyles(props);
    return (
        <div className={classes.root}>
            <ReactMarkdown>
                {props.children}
            </ReactMarkdown>
        </div>
    )
}
